var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"order-placed-div"}},[_c('h4',{staticClass:"fw-bold"},[_vm._v("Your order has been placed successfully.")]),_c('h4',{staticClass:"fw-bold"},[_vm._v(" You will receive the tickets in electronic format at the email address provided. ")])])
}]

export { render, staticRenderFns }